import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="registration-edit"
export default class extends Controller {
  static targets = [
    "inputImproperReason",
    "formImproper",
    "selectState",
    "selectSubmitBtn",
    "apiInfos",
    "pricesSelect",
    "negativeDiffMessage",
    "positiveDiffMessage",
  ];
  static values = { state: String, eventId: Number, registrationId: Number, initialAmount: Number };

  declare inputImproperReasonTarget: HTMLInputElement;
  declare hasInputImproperReasonTarget: boolean;
  declare formImproperTarget: HTMLDivElement;
  declare hasFormImproperTarget: boolean;
  declare stateValue: String;
  declare hasStateValue: boolean;
  declare selectStateTarget: HTMLInputElement;
  declare hasSelectStateTarget: boolean;
  declare selectSubmitBtnTarget: HTMLInputElement;
  declare hasSelectSubmitBtnTarget: boolean;

  declare eventIdValue: Number;
  declare hasEventIdValue: boolean;
  declare registrationIdValue: Number;
  declare hasRegistrationIdValue: boolean;
  declare initialAmountValue: Number;
  declare hasInitialAmountValue: boolean;
  declare pricesSelectTarget: HTMLSelectElement;
  declare hasPricesSelectTarget: boolean;
  declare negativeDiffMessageTarget: HTMLElement;
  declare hasNegativeDiffMessageTarget: boolean;
  declare positiveDiffMessageTarget: HTMLElement;
  declare hasPositiveDiffMessageTarget: boolean;

  connect() {
    if (this.stateValue == "improper") {
      this.displayFormImproper();
    } else {
      this.hideFormImproper();
    }
    this.changeDisabled();
  }

  displayFormImproper() {
    if (this.hasFormImproperTarget && this.formImproperTarget.classList.contains("hidden")) {
      this.formImproperTarget.classList.remove("hidden");
      this.inputImproperReasonTarget.required = true;
    }
  }

  hideFormImproper() {
    if (this.hasFormImproperTarget && !this.formImproperTarget.classList.contains("hidden")) {
      this.formImproperTarget.classList.add("hidden");
      this.inputImproperReasonTarget.required = false;
    }
  }

  toggleFormImproper() {
    this.formImproperTarget.classList.contains("hidden") ? this.displayFormImproper() : this.hideFormImproper();
  }

  changeState() {
    if (this.hasSelectStateTarget) {
      if (this.selectStateTarget.value == "improper") {
        this.displayFormImproper();
      } else {
        this.hideFormImproper();
      }
      this.changeDisabled();
    }
  }

  changeDisabled() {
    if (this.hasSelectSubmitBtnTarget && this.hasSelectStateTarget) {
      this.selectSubmitBtnTarget.disabled =
        this.selectStateTarget.value == "improper" || this.selectStateTarget.value == "";
      this.selectSubmitBtnTarget.className = this.selectSubmitBtnTarget.disabled
        ? "mt-4 block rounded-md bg-gray-300 px-3 py-2 text-center text-sm font-semibold text-gray-600 shadow-sm cursor-not-allowed opacity-50"
        : "mt-4 block rounded-md bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary-light";
    }
  }

  displayPriceMessage(newPrice: Number) {
    let oldPrice = this.initialAmountValue;
    if (!this.hasNegativeDiffMessageTarget || !this.hasPositiveDiffMessageTarget) return;

    if (!oldPrice || !newPrice || oldPrice == newPrice) {
      this.negativeDiffMessageTarget.classList.add("hidden");
      this.positiveDiffMessageTarget.classList.add("hidden");
      this.positiveDiffMessageTarget.parentElement?.classList?.add('invisible')
    } else if (oldPrice > newPrice) {
      this.negativeDiffMessageTarget.classList.remove("hidden");
      this.positiveDiffMessageTarget.classList.add("hidden");
      this.positiveDiffMessageTarget.parentElement?.classList?.remove('invisible')
    } else {
      this.negativeDiffMessageTarget.classList.add("hidden");
      this.positiveDiffMessageTarget.classList.remove("hidden");
      this.positiveDiffMessageTarget.parentElement?.classList?.remove('invisible')
    }
  }

  selectPriceMessage(event) {
    if (event.target.tagName == "SELECT") {
      let selectedOption = event.target.selectedOptions[0];
      if (selectedOption) this.displayPriceMessage(selectedOption.dataset.amount);
    }
  }

  async getPrices(event) {
    if (!this.hasEventIdValue || !this.hasPricesSelectTarget || event.target.value == "") return;
    const spinner = document.getElementById("spinner");
    if (spinner) spinner.classList.remove("hidden");
    this.pricesSelectTarget.innerHTML = "";
    const url = `/events/${this.eventIdValue}/items/${event.target.value}/prices`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content"),
      },
      body: JSON.stringify({ registration_id: this.hasRegistrationIdValue ? this.registrationIdValue : "" }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((json) => {
        if (json.prices) {
          let prices: { id: number; label: string; amount: number; selected: boolean }[] = json.prices;
          prices.forEach((price) => {
            const option = document.createElement("option");
            option.value = price.id.toString();
            option.textContent = price.label;
            option.dataset.amount = price.amount.toString();
            if (price.selected) {
              option.selected = true;
              if (price.amount) this.displayPriceMessage(price.amount);
            }
            this.pricesSelectTarget.appendChild(option);
          });
          this.pricesSelectTarget.parentElement?.classList.remove("hidden");
        }
        if (spinner) spinner.classList.add("hidden");
      });
  }
}
